import { ReactNode } from "react";
import Button from "src/shared/components/Button";

interface Props {
  children: ReactNode;
  onClick: () => void;
  disabled?: boolean;
}

/** One shared treatment for supporting actions throughout the login flow. */
export default function LoginLinkAction({
  children,
  onClick,
  disabled = false,
}: Props): JSX.Element {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      size="small"
      sx={{ minWidth: 0, paddingX: 0.5 }}
    >
      {children}
    </Button>
  );
}
